import { createAction, props } from '@ngrx/store';

import { Channel, ChannelType } from './channels.models';

export const loadChannels = createAction('[Newsfeed/API] Load Newsfeed Channels');
export const loadChannelsSuccess = createAction(
  '[Newsfeed/API] Load Newsfeed Channels success',
  props<{ channels: Channel[] }>()
);
export const loadChannelsFailure = createAction(
  '[Newsfeed/API] Load Newsfeed Channels failure',
  props<{ error: string }>()
);

export const subscribeChannelRequested = createAction(
  '[Newsfeed/API] Request Newsfeed Channel Subscription',
  props<{ fairId: string; channelType: ChannelType; id: string; context: string }>()
);
export const subscribeChannel = createAction(
  '[Newsfeed/API] Subscribe Newsfeed Channel',
  props<{ fairId: string; channelType: ChannelType; id: string; context: string }>()
);
export const subscribeChannelSuccess = createAction(
  '[Newsfeed/API] Subscribe Newsfeed Channel success',
  props<{ channel: Channel; context: string }>()
);
export const subscribeChannelFailure = createAction(
  '[Newsfeed/API] Subscribe Newsfeed Channel failure',
  props<{ error: string }>()
);

export const unsubscribeChannel = createAction(
  '[Newsfeed/API] Unsubscribe Newsfeed Channel',
  props<{ fairId: string; channelType: ChannelType; id: string; context: string }>()
);
export const unsubscribeChannelSuccess = createAction(
  '[Newsfeed/API] Unsubscribe Newsfeed Channel success',
  props<{ channel: Channel; context: string }>()
);
export const unsubscribeChannelFailure = createAction(
  '[Newsfeed/API] Unsubscribe Newsfeed Channel failure',
  props<{ error: string }>()
);

export const markAsVisited = createAction(
  '[Newsfeed/API] Mark Channel as visited',
  props<{ fairId: string; channelType: ChannelType; id: string }>()
);
export const markAsVisitedSuccess = createAction(
  '[Newsfeed/API] Mark Channel as visited success',
  props<{ channel: Channel }>()
);
export const markAsVisitedFailure = createAction(
  '[Newsfeed/API] Mark Channel as visited failure',
  props<{ error: string }>()
);
